import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOutlineNav } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraButton, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
const BADGE = {
    ready: {
        label: 'Ready',
        variant: 'success'
    },
    draft: {
        label: 'Draft',
        variant: 'info'
    },
    empty: {
        label: 'Empty',
        variant: 'neutral'
    },
    missing: {
        label: 'Heading missing',
        variant: 'danger'
    }
};
export const sectionStatusLabel = (s)=>BADGE[s].label;
export function sectionHref(projectId, volumeId, sectionId) {
    return `/proposal/${projectId}/v2/volume/${volumeId}/section/${sectionId}`;
}
/**
 * The volume's section outline (WRT-17): one row per heading with its status,
 * the page budget as the footer, and the headings removed from the document
 * in a collapsed group with "Put it back".
 */ export function ProposalVolumeOutline({ activeSectionId, canEdit, footer, live, onPutBack, projectId, puttingBack, removed, title, volumeId }) {
    const [open, setOpen] = useState(false);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-full min-h-0 flex-col",
        "data-testid": Testids.officeWorkspace.proposalOutline,
        children: [
            /*#__PURE__*/ _jsx(SpecraOutlineNav, {
                className: "min-h-0 flex-1",
                emptyText: "Headings appear here after the first save.",
                footer: footer,
                items: live.map(({ node, n, status })=>({
                        id: node.sectionId,
                        label: `§${n} ${node.title}`,
                        href: sectionHref(projectId, volumeId, node.sectionId),
                        active: node.sectionId === activeSectionId,
                        testId: Testids.officeWorkspace.proposalOutlineItem,
                        trailing: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: BADGE[status].variant,
                            children: BADGE[status].label
                        })
                    })),
                label: `${title} sections`,
                renderLink: renderRouterLink,
                title: title
            }),
            removed.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                className: "border-t border-border px-[var(--space-3)] py-[var(--space-2)]",
                children: [
                    /*#__PURE__*/ _jsxs(SpecraButton, {
                        "aria-expanded": open,
                        className: "w-full justify-start gap-[var(--space-1)]",
                        onClick: ()=>setOpen((o)=>!o),
                        size: "inline",
                        variant: "link",
                        children: [
                            /*#__PURE__*/ _jsx(ChevronRight, {
                                className: `h-3 w-3 transition-transform ${open ? 'rotate-90' : ''}`
                            }),
                            /*#__PURE__*/ _jsx(SpecraText, {
                                size: "body-ui",
                                tone: "muted",
                                children: `Headings removed from the document (${removed.length})`
                            })
                        ]
                    }),
                    open ? /*#__PURE__*/ _jsx("ul", {
                        className: "mt-[var(--space-2)] flex flex-col gap-[var(--space-2)]",
                        children: removed.map(({ node })=>/*#__PURE__*/ _jsxs("li", {
                                className: "flex items-center justify-between gap-[var(--space-2)]",
                                children: [
                                    /*#__PURE__*/ _jsx(SpecraText, {
                                        size: "body-ui",
                                        children: node.title
                                    }),
                                    canEdit ? /*#__PURE__*/ _jsx(SpecraButton, {
                                        "data-testid": Testids.officeWorkspace.putHeadingBack,
                                        isLoading: puttingBack === node.sectionId,
                                        onClick: ()=>onPutBack(node.sectionId),
                                        size: "sm",
                                        variant: "secondary",
                                        children: "Put it back"
                                    }) : null
                                ]
                            }, node.sectionId))
                    }) : null
                ]
            }) : null
        ]
    });
}
